import t from './story08.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,
  regionName: t.regionName,

  prose: [
    // Run 1 — the open: the "ant colony" passage, the controversy, and who profits.
    [
      { text: t.s1P1 },
      { text: t.s1P2 },
      { text: t.s1P3 },
      { text: t.s1P4 },
      { text: t.s1P5 },
    ],
    // Run 2 — resumes after the pull quote: the militias, the environment, the numbers.
    // `s2P4`/`s2P5` are one doc block split by a hard line break, authored as the two
    // paragraphs they read as.
    [
      { text: t.s2P1 },
      { text: t.s2P2 },
      { text: t.s2P3 },
      { text: t.s2P4 },
      { text: t.s2P5 },
    ],
    // Run 3 — the interview proper: the framing line, then Q1–Q3 with their answers.
    [
      { text: t.s3P1 },
      { text: t.s3P2 },
      { text: t.s3P3 },
      { text: t.s3P4 },
      { text: t.s3P5 },
      { text: t.s3P6 },
      { text: t.s3P7 },
    ],
    // Run 4 — Kara's third answer resumes after the Kolwezi figure, then Q4 and Q5.
    [
      { text: t.s4P1 },
      { text: t.s4P2 },
      { text: t.s4P3 },
      { text: t.s4P4 },
      { text: t.s4P5 },
    ],
    // Run 5 — the close: the last answer, and the doc's `[INSERT FOOTER]` disclaimer,
    // which is body copy here because the layout has nowhere else to put it.
    [{ text: t.s5P1 }, { text: t.s5P2 }, { text: t.s5P3 }],
  ],

  captions: [
    // 01 — hero, the mother and baby above Kambove.
    [t.f1P1],
    // 02 — the Shabara Mine.
    [t.f2P1],
    // 03 — the child worker at Kolwezi, beside KCC.
    [t.f3P1],
    // 04 — the book's Frederick Douglass Book Prize.
    [t.f4P1],
  ],

  quotes: [{ text: t.q1 }],
} as const
